(() => {
  let isCleaning = false;
  let timer = null;

  const schedule = () => {
    if (timer) clearTimeout(timer);
    timer = setTimeout(cleanup, 350);
  };

  const refreshCartUI = async () => {
    const sectionIds = [];
    if (document.querySelector('cart-drawer')) sectionIds.push('cart-drawer');
    if (document.getElementById('cart-icon-bubble')) sectionIds.push('cart-icon-bubble');

    // Dawn cart page sections (usually these custom elements exist)
    if (document.querySelector('main-cart-items')) sectionIds.push('main-cart-items');
    if (document.querySelector('main-cart-footer')) sectionIds.push('main-cart-footer');

    if (!sectionIds.length) return;

    try {
      const res = await fetch(`/cart?sections=${sectionIds.join(',')}`, {
        headers: { Accept: 'application/json' }
      });
      if (!res.ok) return;
      const sections = await res.json();

      // Cart drawer
      const drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.renderContents === 'function') {
        drawer.renderContents({ sections });
      }

      // Bubble
      const bubble = document.getElementById('cart-icon-bubble');
      if (bubble && sections['cart-icon-bubble']) {
        const doc = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
        const newBubble = doc.getElementById('cart-icon-bubble');
        if (newBubble) bubble.replaceWith(newBubble);
      }

      // Cart page sections
      const cartItems = document.querySelector('main-cart-items');
      if (cartItems && sections['main-cart-items']) {
        const doc = new DOMParser().parseFromString(sections['main-cart-items'], 'text/html');
        const newEl = doc.querySelector('main-cart-items');
        if (newEl) cartItems.replaceWith(newEl);
      }

      const cartFooter = document.querySelector('main-cart-footer');
      if (cartFooter && sections['main-cart-footer']) {
        const doc = new DOMParser().parseFromString(sections['main-cart-footer'], 'text/html');
        const newEl = doc.querySelector('main-cart-footer');
        if (newEl) cartFooter.replaceWith(newEl);
      }
    } catch (e) {}
  };

  const cleanup = async () => {
    if (isCleaning) return;
    isCleaning = true;

    try {
      const res = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
      if (!res.ok) return;
      const cart = await res.json();

      const isGift = (item) =>
        item &&
        item.properties &&
        (item.properties._tmd_free_gift === 'true' || item.properties._tmd_free_gift === true);

      const nonGiftVariantIds = new Set(
        (cart.items || [])
          .filter((it) => !isGift(it))
          .map((it) => String(it.id))
      );

      const giftsToRemove = (cart.items || []).filter((it) => {
        if (!isGift(it)) return false;
        const parentVariant = it.properties?._tmd_gift_for_variant;
        if (!parentVariant) return false; // only auto-remove gifts that were linked
        return !nonGiftVariantIds.has(String(parentVariant));
      });

      if (!giftsToRemove.length) return;

      for (const giftItem of giftsToRemove) {
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: giftItem.key, quantity: 0 })
        });
      }

      await refreshCartUI();
    } catch (e) {
      // swallow
    } finally {
      isCleaning = false;
    }
  };

  // Run once on load (safe)
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', cleanup);
  } else {
    cleanup();
  }

  // Hook into fetch so any cart change triggers cleanup
  const origFetch = window.fetch;
  window.fetch = async (...args) => {
    const resp = await origFetch(...args);
    try {
      const url = typeof args[0] === 'string' ? args[0] : args[0]?.url;
      if (!isCleaning && url && /\/cart\/(add|change|update)\.js/i.test(url)) {
        schedule();
      }
    } catch (e) {}
    return resp;
  };
})();